import { gql } from '@apollo/client';

export const getNotificationOverviewList = gql`
  query listNotificationsOverview(
    $filter: FilterNotifications
    $pagingOptions: PagingOptionsInput!
  ) {
    notifications(filter: $filter, pagingOptions: $pagingOptions) {
      data {
        id
        message
        machine {
          alias
          materialNumber
          serialNumber
        }
        createdAt
        updatedAt
      }
      metadata {
        totalCount
      }
    }
  }
`;
